import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchAllBooks, setBookPublished, deleteBook } from "../../lib/booksApi";

export default function AdminBooksPage() {
  const [books, setBooks] = useState(null);
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    fetchAllBooks().then(({ data }) => setBooks(data ?? []));
  }, []);

  async function handleTogglePublished(book) {
    setBusyId(book.id);
    const { error } = await setBookPublished(book.id, !book.published);
    if (!error) {
      setBooks((prev) =>
        prev.map((b) => (b.id === book.id ? { ...b, published: !b.published } : b))
      );
    } else {
      window.alert(error.message);
    }
    setBusyId(null);
  }

  async function handleDelete(book) {
    const confirmed = window.confirm(
      `Delete "${book.title}"? This removes it (and its uploaded files) permanently and can't be undone.`
    );
    if (!confirmed) return;

    setBusyId(book.id);
    const { error } = await deleteBook(book);
    if (!error) {
      setBooks((prev) => prev.filter((b) => b.id !== book.id));
    } else {
      window.alert(error.message);
    }
    setBusyId(null);
  }

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-bold text-zinc-900">Books</h1>
        <Link
          to="/admin/books-portal/books/new"
          className="rounded-md bg-zinc-900 px-4 py-2 text-sm font-semibold text-white hover:bg-zinc-800"
        >
          + New Book
        </Link>
      </div>

      {books === null ? (
        <p className="text-zinc-600">Loading…</p>
      ) : !books.length ? (
        <p className="text-zinc-600">No books yet — add your first one.</p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {books.map((book) => {
            const busy = busyId === book.id;
            return (
              <div
                key={book.id}
                className="rounded-lg border border-zinc-200 bg-white p-4 shadow-sm"
              >
                <h2 className="font-semibold text-zinc-900">{book.title}</h2>
                <p className="mt-1 text-sm text-zinc-500">/books/{book.slug}</p>
                <p className="mt-1 text-xs text-zinc-400">
                  {book.published ? "Published" : "Draft"}
                </p>
                <div className="mt-3 flex flex-wrap items-center gap-3">
                  <a
                    href={`/books/${book.slug}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-medium text-sky-600 hover:underline"
                  >
                    View landing page →
                  </a>
                  <a
                    href={`/books/${book.slug}/read`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-medium text-sky-600 hover:underline"
                  >
                    View reader →
                  </a>
                  <Link
                    to={`/admin/books-portal/books/${book.id}/edit`}
                    className="text-sm font-medium text-zinc-600 hover:underline"
                  >
                    Edit
                  </Link>
                </div>
                <div className="mt-3 flex flex-wrap items-center gap-3 border-t border-zinc-100 pt-3">
                  <button
                    type="button"
                    onClick={() => handleTogglePublished(book)}
                    disabled={busy}
                    className="text-sm font-medium text-amber-600 hover:underline disabled:opacity-50"
                  >
                    {book.published ? "Unpublish" : "Publish"}
                  </button>
                  <button
                    type="button"
                    onClick={() => handleDelete(book)}
                    disabled={busy}
                    className="text-sm font-medium text-red-600 hover:underline disabled:opacity-50"
                  >
                    Delete
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
